import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";

import React from "react";

const NavBarPermissions = (props) => {
  const { role } = props;

  return (
    <>
      <Card className="bg-gray">
        <Card.Body>
          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">
                Navigation Bar
              </span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row style={{ marginBottom: "100px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">Queues</span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Data Tables
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">Rules</span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">Reporting</span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">Admin</span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Read" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">Settings</span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Col style={{ display: "flex", justifyContent: "center" }}>
                <Card style={{ width: "500px", marginTop: "25px" }}>
                  <Row style={{ marginTop: "10px", marginBottom: "10px" }}>
                    <Col className="offset-1 textSmallFontBig">
                      Permissions:
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <Col sm={3} className="offset-1 textSmallFontBig">
                      <div>Can Edit</div>
                    </Col>
                    <Col>
                      <div>(Visible and can perform screen action)</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={3} className="offset-1 textSmallFontBig">
                      <div>Can Read</div>
                    </Col>
                    <Col>
                      <div>(Visible on Screen but Cannot Edit)</div>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: "10px" }}>
                    <Col sm={3} className="offset-1 textSmallFontBig">
                      <div>Cannot Read</div>
                    </Col>
                    <Col>
                      <div>(Not visible on Screen)</div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default NavBarPermissions;
